// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acct-select-wrapper {
  position: relative;
  display: block;
}

.acct-select-btn {
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.acct-select-btn.disabled {
  background-color: var(--bs-secondary-bg);
  cursor: not-allowed;
  opacity: 0.65;
}

.acct-select-panel {
  position: absolute;
  z-index: 1055;
  width: 100%;
  background: var(--bs-secondary-bg);
  color: var(--bs-body-color);
  margin-top: 2px;
}

.acct-select-list {
  max-height: 260px;
  overflow-y: auto;
}

.acct-select-group-header {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--bs-secondary-color);
  background-color: var(--bs-tertiary-bg);
  border-top: 1px solid var(--bs-border-color);
  padding-top: 6px;
  padding-bottom: 4px;
}

.acct-select-option {
  cursor: pointer;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.acct-select-option:hover {
  background-color: var(--bs-secondary-bg);
}

.acct-select-option.selected {
  background-color: #0d6efd;
  color: #fff;
}

.acct-select-option.highlighted {
  background-color: var(--bs-primary-bg-subtle);
  outline: 2px solid var(--bs-primary);
  outline-offset: -2px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
